export const isTruthy = (val: string | boolean | number) => val === true || val === 'true' || val === 1 || val === '1';
